import React from 'react';

const SupportIcon = ({ fill }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 0C3.35506 0 0 3.14464 0 7.03102C0 8.73481 0.653437 10.3675 1.84375 11.6479V14.5601C1.84375 14.9502 2.34897 15.1474 2.64394 14.8708L4.24722 13.3678C9.22819 15.6145 15 12.2007 15 7.03102C15 3.14526 11.6456 0 7.5 0V0ZM7.5 11.4518C7.24197 11.4518 7.03281 11.2557 7.03281 11.0138C7.03281 10.7719 7.24197 10.5759 7.5 10.5759C7.75803 10.5759 7.96719 10.7719 7.96719 11.0138C7.96719 11.2557 7.75803 11.4518 7.5 11.4518ZM7.96875 8.34203V9.25603C7.96875 9.49873 7.75887 9.69546 7.5 9.69546C7.24113 9.69546 7.03125 9.4987 7.03125 9.25603V7.93917C7.03125 7.69647 7.24113 7.49974 7.5 7.49974C8.53472 7.49974 9.37656 6.71054 9.37656 5.74052C9.37656 4.7705 8.53475 3.9813 7.5 3.9813C6.46525 3.9813 5.62344 4.7705 5.62344 5.74052C5.62344 5.98322 5.41356 6.17995 5.15469 6.17995C4.89581 6.17995 4.68594 5.98319 4.68594 5.74052C4.68594 4.28587 5.94831 3.10242 7.5 3.10242C9.05169 3.10242 10.3141 4.28587 10.3141 5.74052C10.3141 7.04549 9.29809 8.13217 7.96875 8.34203Z"
        fill={fill}
      />
    </svg>
  );
};

export default SupportIcon;
